import { render, staticRenderFns } from "./popular-products-section.vue?vue&type=template&id=7215a32e&"
import script from "./popular-products-section.vue?vue&type=script&lang=js&"
export * from "./popular-products-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports